// extracted by mini-css-extract-plugin
module.exports = {"noticeBanner":"noticeBanner--b3cab"};